var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.seasons)?_c('div',{staticClass:"c-seasons"},[_vm._t("header"),_c(_setup.seasonsComponent,{tag:"component",attrs:{"seasons":_vm.seasons,"season":_setup.season},on:{"update:season":function($event){_setup.season=$event}}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }